import { useEffect, useMemo, useState } from 'react';
/**
 * Factory function for the useFetchData hook
 * @param fetchMethod - Method which returns the children for the given id and page
 */
export function getFetchDataHook(fetchMethod) {
  return ({
    id,
    enabled
  }) => {
    const [fetchStatus, setFetchStatus] = useState('idle');
    const [fetchData, setFetchData] = useState();
    const [page, setPage] = useState(0);
    const [loadedPage, setLoadedPage] = useState(-1);
    const [canLoadMore, setCanLoadMore] = useState(false);
    useEffect(() => {
      if (page > loadedPage && enabled) {
        setFetchStatus('loading');
        setLoadedPage(page); // this will prevent multiple loading of the same page

        (async () => {
          try {
            const asyncData = await fetchMethod(id, page);
            setFetchData(d => d ? [...d, ...asyncData.children] : asyncData.children);
            setCanLoadMore(!!asyncData.canLoadMore);
            setFetchStatus('success');
          } catch {
            setFetchStatus('error');
          }
        })();
      }
    }, [page, loadedPage, enabled, id]);

    // Function which should be called when the load more button has been clicked
    const fetchNextPage = useMemo(() => {
      if (canLoadMore) {
        return () => {
          // Reset data
          setCanLoadMore(false);
          // Increase page number for fetching
          setPage(p => p + 1);
          // Set fetch status to prevent content jumping
          setFetchStatus('loading');
        };
      }
      return () => void 0;
    }, [canLoadMore]);
    return useMemo(() => ({
      data: fetchData,
      status: fetchStatus,
      fetchNextPage,
      hasNextPage: canLoadMore
    }), [fetchData, fetchStatus, fetchNextPage, canLoadMore]);
  };
}